import { render, staticRenderFns } from "./CartPrice.vue?vue&type=template&id=27a46a3c&"
import script from "./CartPrice.vue?vue&type=script&lang=js&"
export * from "./CartPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports